import i18n from '@/locales';

const LOCATION_MAP_KEYS = [
  'locations',
  'exclude_locations',
  'job_locations',
  'job_exclude_locations',
  'company_locations',
  'company_exclude_locations',
  'people_locations',
  'exclude_people_locations',
  'advertisement_target_locations',
  'advertisement_exclude_target_locations',
];

const SLUG_LIST_KEYS = [
  'news_categories',
  'management_levels',
  'departments',
  'department_functions',
];

const rulesFor = (keys, rule) =>
  Object.fromEntries(keys.map((key) => [key, rule]));

export function transformFilters(rawData, lookups = {}) {
  if (!rawData) {
    return {};
  }

  const { 
    sequenceList = [], 
    locationListMap = new Map(), 
    techCategoryList =[], 
    mediaList = [],
    companySavedList = [],
    peopleSavedList = [],
    managementLevels = [],
    departments = [],
    departmentFunctions = [],
   } = lookups;

   const transformationRules = {
    ...rulesFor(LOCATION_MAP_KEYS, (data) => mapValToMap(data, locationListMap)),
    ...rulesFor(SLUG_LIST_KEYS, (data) => mapObjectsToList(data, 'slug', 'name')),
    exclude_departments: (data) =>
      mapValuesToList(data, departments, 'slug', 'name'),
    exclude_department_functions: (data) =>
      mapValuesToList(data, departmentFunctions, 'slug', 'name'),
    companies: (data) => mapCompanyToMap(data) || new Map(),
    sequences: (data) => mapValuesToList(data, sequenceList, 'sequence_identifier', 'name'),
    vertical_sub_categories: (data) => mapObjectsToList(data, 'vertical_sub_category_id', 'name'),
    vertical_categories: (data) => mapObjectsToList(data, 'vertical_category_id', 'name'),
    verticals: (data) => mapObjectsToList(data, "vertical_id", "name"),
    technologies: (data) => mapObjectsToList(data, "id", "name", ['logo_url']),
    categories: (data) => mapObjectsToList(data, 'category_id', 'name'),
    social_media: (data) => mapValuesToList(data, mediaList, 'value', 'name'),
    company_groups: (data) => mapValuesToList(data, companySavedList, 'group_id', 'name'),
    people_groups: (data) => mapValuesToList(data, peopleSavedList, 'group_id', 'name'),
  }

  const result = {};
  for (const key in rawData) {
    if (Object.prototype.hasOwnProperty.call(rawData, key)) {
      if (transformationRules[key]) {
        result[key] = transformationRules[key](rawData[key]);
      } else {
        result[key] = rawData[key];
      }
    }
  }
  return result;
}


function mapObjectsToList(rawObjects, valueKey, labelKey, extraKeys = []) {
  if (!Array.isArray(rawObjects) || rawObjects.length === 0) {
        return [];
    }

    return rawObjects.map(obj => {
        const newObj = {
            label: obj[labelKey],
            value: obj[valueKey]
        };

        for (const key of extraKeys) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                newObj[key] = obj[key];
            }
        }

        return newObj;
    });
}


function mapValuesToList(rawValues, lookupList, valueKey = 'value', labelKey = 'label') {
    if (!Array.isArray(rawValues) || rawValues.length === 0) {
        return [];
    }
    
    if (!Array.isArray(lookupList) || lookupList.length === 0) {
        return rawValues.map(value => ({
            label: i18n.t('filterRemoved'),
            value: value
        }));
    }

    return rawValues.map(value => {
        const foundItem = lookupList.find(item => item[valueKey] === value);

        if (foundItem) {
            return { 
                label: foundItem[labelKey], 
                value: foundItem[valueKey] 
            };
        }
        
        return { 
            label: i18n.t('filterRemoved'), 
            value: value 
        };
    });
}


function mapValToMap(rawValues, lookupList) {
  if (!Array.isArray(rawValues) || rawValues.length === 0) {
    return new Map();
  }

  const resultMap = new Map();

  for (const rawVal of rawValues) {
    const hit = lookupList?.get(rawVal);
    resultMap.set(rawVal, hit || { label: rawVal, value: rawVal });
  }

  return resultMap;
}

function mapCompanyToMap(rawValues) {
  if (!Array.isArray(rawValues) || rawValues.length === 0) {
    return new Map();
  }

  const resultMap = new Map();

  for (const value of rawValues) {
    const { domain_search_id, domain, logo_url, company_name } = value;
    resultMap.set(domain_search_id, {
      label: company_name,
      value: domain_search_id,
      domain,
      logo_url,
    })
  }

  return resultMap;
}
